import graphClient from '../graphClient/graphClient';
import { getPositionRequestsOfDepartment } from './graphPositionsQueries/getPositionRequestsOfDepartment';

export const getPositionRequestsOfDepartmentGraph = async (departmentId: number) => {
  return await graphClient.query({
    query: getPositionRequestsOfDepartment,
    variables: { departmentId: departmentId },
  });
};
